import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';

const AboutPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.stat, .about-text, .tech-item').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="about-page hero-sub">
                <div className="container">
                    <div className="about-content">
                        <div className="about-text">
                            <h1 className="section-title gradient-text">Pioneering <span>AI Excellence</span></h1>
                            <p className="hero-description">
                                AskNow is dedicated to bridging the gap between cutting-edge AI research and practical, scalable business applications.
                            </p>
                            <div className="about-long-text">
                                <p>Founded in 2023, our mission is to empower organizations of all sizes with the intelligence they need to thrive in an increasingly data-driven world. We believe that AI should be accessible, secure, and profoundly impactful.</p>
                                <p>Our team consists of world-class AI researchers, data scientists, and engineers who are passionate about solving the world's most complex problems through technology.</p>
                            </div>
                            <div className="stats">
                                <div className="stat">
                                    <div className="stat-number">10M+</div>
                                    <div className="stat-label">Data Points Analyzed</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-number">500+</div>
                                    <div className="stat-label">Global Clients</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-number">24/7</div>
                                    <div className="stat-label">System Support</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-number">99.9%</div>
                                    <div className="stat-label">Uptime SLA</div>
                                </div>
                            </div>
                        </div>

                        <div className="about-visual-grid">
                            <div className="tech-grid">
                                <div className="tech-item">Innovation</div>
                                <div className="tech-item">Security</div>
                                <div className="tech-item">Scalability</div>
                                <div className="tech-item">Integrity</div>
                                <div className="tech-item">Speed</div>
                                <div className="tech-item">Excellence</div>
                            </div>
                        </div>
                    </div>

                    <div className="our-mission-section">
                        <h2 className="section-title">Our <span>Core Values</span></h2>
                        <div className="features-grid">
                            <div className="feature-card">
                                <h3>Integrity First</h3>
                                <p>We build AI that is ethical, transparent, and respectful of human values and privacy.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Constant Innovation</h3>
                                <p>We never stop pushing the boundaries of what's possible in artificial intelligence.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Client Success</h3>
                                <p>Your growth is our primary metric. We are partners in your journey to digital transformation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default AboutPage;
